import {
  GET_ORGANISMES_PAC,
  GET_PAC_CATEGRY_PARAM,
  SEND_PAC_INFOS,
  SET_ORGANISMES_PAC,
  SET_PAC_CATEGRY_PARAM,
  SET_PAC_OBJECT,
  SET_PAC_RESPONSE,
} from './constants';

const getOrganismesPAC = () => ({
  type: GET_ORGANISMES_PAC,
});

const setOrganismesPAC = (payload: any) => ({
  type: SET_ORGANISMES_PAC,
  payload,
});

const getCategoryParamPAC = (payload: any) => ({
  type: GET_PAC_CATEGRY_PARAM,
  payload,
});

const setCategoryParamPAC = (payload: any) => ({
  type: SET_PAC_CATEGRY_PARAM,
  payload,
});

const updatePACObject = (payload: any) => ({
  type: SET_PAC_OBJECT,
  payload,
});

const sendPacInfos = () => ({
  type: SEND_PAC_INFOS,
});

const setPacResponse = (payload: any) => ({
  type: SET_PAC_RESPONSE,
  payload,
});

export {
  getOrganismesPAC,
  setOrganismesPAC,
  updatePACObject,
  getCategoryParamPAC,
  setCategoryParamPAC,
  sendPacInfos,
  setPacResponse,
};
